{
  "title": "Transfers",
  "subtitle": "Move stock between your locations. The receiving side confirms what really arrived.",
  "new": "New transfer",
  "export": "Export to Excel",
  "how": {
    "send": {
      "title": "Send",
      "text": "Stock leaves the source and waits in “In transit”."
    },
    "receive": {
      "title": "Receive",
      "text": "The destination enters what arrived. Missing items can still come, or be closed as a transit loss."
    },
    "oneStep": {
      "title": "One step",
      "text": "Between places of the same site, or with the quick transfer permission: sent and received at once."
    }
  },
  "tabs": {
    "in_transit": "In transit",
    "drafts": "Drafts",
    "received": "Received",
    "all": "All"
  },
  "status": {
    "draft": "Draft",
    "sent": "Sent",
    "partially_received": "Partly received",
    "received": "Received",
    "cancelled": "Cancelled",
    "direct": "Done in one step"
  },
  "mode": {
    "two_step": "Two steps",
    "direct": "One step",
    "sameSite": "Same site: {{name}}"
  },
  "columns": {
    "number": "Number",
    "fromTo": "From → To",
    "lines": "Lines",
    "sent": "Sent",
    "onTheWay": "On the way for",
    "status": "Status",
    "action": "Action",
    "product": "Product"
  },
  "age": {
    "hours_one": "{{count}} hour",
    "hours_other": "{{count}} hours",
    "days_one": "{{count}} day",
    "days_other": "{{count}} days"
  },
  "list": {
    "search": "Transfer number",
    "receive": "Receive",
    "continue": "Continue",
    "notSent": "Not sent yet",
    "sentOn": "sent {{date}}",
    "receivedOn": "Received {{date}}",
    "late": "{{age}} · late",
    "lateRule_one": "Transfers not received after {{count}} day are flagged",
    "lateRule_other": "Transfers not received after {{count}} days are flagged",
    "lateCount_one": "{{count}} late",
    "lateCount_other": "{{count}} late",
    "lines_one": "{{count}} line",
    "lines_other": "{{count}} lines",
    "showing_one": "Showing {{count}} transfer",
    "showing_other": "Showing {{count}} transfers",
    "loadMore": "Load more"
  },
  "empty": {
    "in_transit": "Nothing on the way",
    "drafts": "No draft",
    "received": "No transfer received yet",
    "all": "No transfer yet",
    "text": "Move stock between two places with New transfer."
  },
  "route": {
    "from": "From",
    "to": "To",
    "inTransit": "In transit",
    "oneStep": "One step",
    "sentBy": "Sent by {{name}}"
  },
  "editor": {
    "new": "New",
    "title": "Move stock",
    "saving": "Saving…",
    "saved": "Saved automatically at {{time}} · stock has not moved yet",
    "notSaved": "Saved automatically as soon as you add a product",
    "where": "From where to where",
    "from": "From location",
    "to": "To location",
    "choose": "Choose…",
    "date": "Date",
    "note": "Note",
    "sameSite": "Both places are in {{name}}: the stock moves in one step, without “In transit”.",
    "quick": "Move it in one step",
    "quickText": "Sent and received at once, without “In transit”. Use it when the stock is already there.",
    "lines_one": "Products to move · {{count}} line",
    "lines_other": "Products to move · {{count}} lines",
    "scannerReady": "Scanner ready",
    "product": "Product",
    "available": "Available",
    "quantity": "Quantity",
    "removeLine": "Remove the line",
    "noLines": "No product yet: scan a barcode or type a name above.",
    "summary": "Summary",
    "linesLabel": "Lines",
    "value": "Value",
    "explainTwoSteps": "When you send, stock leaves the source and waits in “In transit” until the destination receives it.",
    "explainDirect": "When you move it, stock leaves the source and enters the destination at once.",
    "send": "Send",
    "moveNow": "Move now",
    "cannotSend": "Your role prepares transfers; someone allowed to send will finish it.",
    "keepDraft": "Keep as draft",
    "discard": "Discard draft",
    "discardTitle": "Discard this transfer?",
    "discardText": "Nothing has moved. The draft keeps its number and shows as Cancelled.",
    "discarded": "Transfer discarded",
    "sent": "{{number}} sent: it is now in transit",
    "moved": "{{number}} moved",
    "fixIssues": "Some information is missing: see the fields in red",
    "atDestination": "At destination",
    "limits": "Min {{min}} · max {{max}}",
    "fillToMax": "Fill to max: {{quantity}}",
    "fillToMaxHint": "Brings the destination up to its maximum, with no more than the source has."
  },
  "receive": {
    "title": "Receive transfer",
    "receivedBy": "Received by you, {{name}}",
    "what": "What arrived?",
    "whatHint": "Count the boxes, then type what you really have.",
    "everything": "Everything arrived as sent",
    "before": "Received before",
    "now": "Received now",
    "missing": "Still missing",
    "complete": "Complete",
    "receivedBefore": "Received before",
    "missingShort": "{{quantity}} missing",
    "missingOne": "{{quantity}} {{unit}} of {{name}} are missing. What should happen?",
    "missingMany_one": "{{count}} product is not complete. What should happen?",
    "missingMany_other": "{{count}} products are not complete. What should happen?",
    "choose": "Choose one. You can still change your mind before you confirm.",
    "more": "More will come",
    "moreText": "The transfer stays “Partly received”. What is missing stays in transit until it arrives.",
    "close": "Close with a difference",
    "closeText": "What is missing is recorded as a “Transit loss” adjustment and the transfer is closed.",
    "closeTextValue": "What is missing is recorded as a “Transit loss” adjustment ({{value}} TND) and the transfer is closed.",
    "allThere": "Everything that was sent is here.",
    "note": "Note (optional)",
    "notNow": "Not now",
    "confirm": "Confirm receipt",
    "confirmOpen": "Confirm · keep transfer open",
    "confirmClose": "Confirm · close transfer",
    "done": "{{number}} received",
    "partly": "{{number}} partly received: the rest is still on the way",
    "enterFirst": "Enter what arrived, or use “Everything arrived as sent”. Type 0 for a product that did not come."
  },
  "detail": {
    "title": "Transfer",
    "mode": "Mode",
    "received": "Received",
    "lost": "Lost on the way",
    "lines": "Products",
    "receipts": "Receipts",
    "receiptLine_one": "{{count}} product received by {{name}}",
    "receiptLine_other": "{{count}} products received by {{name}}",
    "closedShort": "Closed with a difference",
    "lossTitle": "Closed with a difference",
    "loss": "Transit loss: {{number}}",
    "lossValue": "Transit loss: {{number}} · {{value}} TND",
    "cancelled": "Discarded {{when}} by {{name}}. Nothing moved."
  }
}
